import { APIcaller, APIcallerv2 } from './APIcaller';
import { CATEGORY_TYPES_OBJECT } from '@commons/constants/categoryTypes';

const getProductsOfClient = () => APIcallerv2.apiGet('/products');

const getPaginatedProductsOfClient = (
  { page, limit, search, orderBy, orderType },
  customParams,
) => {
  const url = `/products/paginated?page=${page}&limit=${limit}&search=${search}&orderBy=${orderBy}&orderType=${orderType}`;

  return APIcallerv2.apiPost(url, { ...customParams });
};

const exportProducts = (productIds) => APIcaller.apiPost('/admin/products/export', { productIds });

const exportIncoData = (productIds) =>
  APIcaller.apiPost('/admin/products/export-inco-data', { productIds });

const getProductsCategories = () =>
  APIcallerv2.apiGet(`/categories?type=${CATEGORY_TYPES_OBJECT.PRODUCT}`);

const getById = (id) => APIcallerv2.apiGet(`/products/${id}`);

const getProductMappings = (productId) => APIcallerv2.apiGet(`/products/${productId}/recipes`);

const updateProduct = (product, productCashierProductMappings, channelPrices) =>
  APIcaller.apiPatch(`/admin/products/${product.id}`, {
    product,
    productCashierProductMappings,
    channelPrices,
  });

const saveProductWithProductionParameters = (
  product,
  storeIds,
  price,
  hasStock,
  launchDate,
  endDate,
  noonMinimum,
  dailyMinimum,
  eveningMinimum,
  targetProductionWasteRate,
  channelPrices,
) => {
  const payload = {
    product,
    storeIds,
    price,
    hasStock,
    launchDate,
    endDate,
    targetProductionWasteRate,
    channelPrices,
  };

  if (dailyMinimum !== '') {
    payload.dailyMinimum = dailyMinimum;
  }

  if (noonMinimum !== '') {
    payload.noonMinimum = noonMinimum;
  }

  if (eveningMinimum !== '') {
    payload.eveningMinimum = eveningMinimum;
  }

  return APIcaller.apiPost('/admin/products/production', payload);
};

const updateStoreProductionParameters = (
  productId,
  storeId,
  price,
  hasStock,
  launchDate,
  endDate,
  noonMinimum,
  dailyMinimum,
  eveningMinimum,
  targetProductionWasteRate = null,
) => {
  const payload = {
    price,
    hasStock,
    launchDate,
    endDate,
    targetProductionWasteRate,
  };

  if (dailyMinimum !== '') {
    payload.dailyMinimum = dailyMinimum;
  }

  if (noonMinimum !== '') {
    payload.noonMinimum = noonMinimum;
  }

  if (eveningMinimum !== '') {
    payload.eveningMinimum = eveningMinimum;
  }

  return APIcaller.apiPatch(`/admin/products/${productId}/stores/${storeId}/production`, payload);
};

const getProductionStores = (productId) => APIcallerv2.apiGet(`/products/${productId}/stores`);

const getCashierProducts = (productId) =>
  APIcallerv2.apiGet(`/products/${productId}/cashier-products`);

const deleteStoreProductMapping = (storeId, productId) =>
  APIcaller.apiDelete(`/admin/products/${productId}/stores/${storeId}`);

const deleteCashierProductAssociation = (productId, cashierProductId) =>
  APIcaller.apiDelete(`/admin/products/${productId}/cashier-products/${cashierProductId}`);

const associateCashierProductsToProduct = (productId, cashierProductIds) =>
  APIcaller.apiPost(`/admin/products/${productId}/cashier-products`, { cashierProductIds });

const associateCashierProductToProduct = (cashierProductId, productId) =>
  APIcaller.apiPost(`/admin/products/${productId}/cashier-products/${cashierProductId}`);

const getProductsOfClientWithCashierProductsMappingRelevance = (clientId, cashierProductIds) =>
  APIcaller.apiPost(`/admin/products/with-cashier-product-mapping-relevance`, {
    clientId,
    cashierProductIds,
  });

const deleteProductByIds = (clientId, productIds) =>
  APIcaller.apiDelete(`/admin/products`, { clientId, productIds });

const disableProductByIds = (productIds) =>
  APIcaller.apiPatch(`/admin/products/disable`, { productIds });

const enableProductByIds = (productIds) =>
  APIcaller.apiPatch(`/admin/products/enable`, { productIds });

const patchCategoriesSubCategories = (productIds, itemId, itemType) =>
  APIcaller.apiPatch('/admin/products/categories-sub-categories', {
    productIds,
    itemId,
    itemType,
  });

const getCashierProductsWithProductMatchingScores = (productId) =>
  APIcallerv2.apiGet(`/products/${productId}/cashier-products/matching-scores`);

const getCashierProductWithSimpleModifierByProductId = (productId) =>
  APIcallerv2.apiGet(`/products/${productId}/cashier-products-with-simple-modifier`);

const getBatchUpdateTemplateByClientId = () =>
  APIcallerv2.apiGet(`/products/import/batch-update/template`, {}, 'blob');

const validateBatchUpdateTemplate = (formattedProducts) =>
  APIcallerv2.apiPost(`/products/import/batch-update/validate`, formattedProducts);

const batchUpdateImport = (products) =>
  APIcallerv2.apiPost(`/products/import/batch-update/import`, products);

export const product = {
  getProductsOfClient,
  getPaginatedProductsOfClient,
  getProductsCategories,
  getById,
  getProductMappings,
  updateProduct,
  saveProductWithProductionParameters,
  updateStoreProductionParameters,
  getProductionStores,
  deleteStoreProductMapping,
  deleteCashierProductAssociation,
  getCashierProducts,
  associateCashierProductToProduct,
  associateCashierProductsToProduct,
  deleteProductByIds,
  disableProductByIds,
  enableProductByIds,
  getProductsOfClientWithCashierProductsMappingRelevance,
  exportProducts,
  patchCategoriesSubCategories,
  getCashierProductsWithProductMatchingScores,
  exportIncoData,
  getCashierProductWithSimpleModifierByProductId,
  getBatchUpdateTemplateByClientId,
  validateBatchUpdateTemplate,
  batchUpdateImport,
};
